export default __webpack_public_path__ + "static/media/feature-network-3.aae596f3.png";